exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/*!\r\n * angularjs-color-picker v3.4.8\r\n * https://github.com/ruhley/angular-color-picker/\r\n *\r\n * Copyright 2017 ruhley\r\n *\r\n * 2017-10-06 09:52:03\r\n *\r\n */.color-picker-wrapper .color-picker-input-wrapper{width:100%}.color-picker-wrapper .color-picker-swatch:not(.input-group-addon){height:28px}.color-picker-wrapper.color-picker-swatch-only .input-group .input-group-addon{border-radius:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/postcss-loader!../node_modules/angularjs-color-picker/dist/themes/angularjs-color-picker-bootstrap.min.css
// module id = 551
// module chunks = 3